module.exports = __webpack_public_path__ + "img/login-dental-hero.d54da4b9.webp";